import { viewport } from '../../utils/viewport';

document
  .querySelectorAll('.pm-card img[data-isrc]')
  .forEach((el) => viewport.observe(el, () => (el.src = el.dataset.isrc)));